import { JourneyPlannerProvider } from "./JourneyPlannerContext";
import { ReactNode } from "react";
import JourneyPlanner from "./JourneyPlanner";

function JourneyPlannerShell({ children }: { children: ReactNode }) {
  return (
    <JourneyPlannerProvider>
      <JourneyPlanner>{children}</JourneyPlanner>
    </JourneyPlannerProvider>
  );
}

export default JourneyPlannerShell;
